module.exports = __webpack_public_path__ + "BACKGROUND.3d27e316a284445397a9.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/BACKGROUND.png
// module id = ../../../../../src/assets/images/BACKGROUND.png
// module chunks = styles